// Content config for /functies/* pages.
// These extend the existing landings.js pattern but live separately
// to keep the SEO ecosystem maintainable.

export const FUNCTIES = {
  wedstrijdanalyse: {
    slug: "wedstrijdanalyse",
    eyebrow: "Functie · Wedstrijdanalyse",
    title: "Wedstrijdanalyse — van protocol naar prestatie.",
    subtitle:
      "Upload je dressuurprotocol. Krijg automatisch scores per onderdeel, jurycommentaar, trends en de Equestrian Performance Index (EPI). Begrijp waarom je verloor — en hoe je wint.",
    primaryCTA: { label: "Analyseer eerste protocol", href: "/#waitlist" },
    secondaryCTA: { label: "Bekijk doelgroep wedstrijdruiters", href: "/doelgroepen/wedstrijdruiters" },
    audience: "Voor wedstrijdruiters, dressuurruiters, springruiters en hun trainers.",
    features: [
      "Protocolfoto uploaden (voor- en achterkant)",
      "Klasse, proefnummer en jurylid herkennen",
      "Scores per onderdeel",
      "Commentaar automatisch samenvatten",
      "Sterke en zwakke punten",
      "Trend per paard-ruiter combinatie",
      "EPI — Equestrian Performance Index",
      "KNHS uitslagen koppelen",
    ],
    faq: [
      {
        q: "Werkt protocol analyse ook voor FEI proeven?",
        a: "Ja. Naast KNHS proeven herkent EquiSight ook FEI en internationale dressuurproeven.",
      },
      {
        q: "Hoe upload ik mijn protocol?",
        a: "Maak een foto van de voor- en achterkant. EquiSight herkent klasse, jurylid en scores automatisch.",
      },
      {
        q: "Wat is de EPI?",
        a: "De Equestrian Performance Index is een score die jouw prestaties over meerdere wedstrijden en onderdelen samenbrengt. Zo zie je trends, niet alleen losse cijfers.",
      },
    ],
  },

  hoefsmid: {
    slug: "hoefsmid",
    eyebrow: "Functie · Hoefsmid module",
    title: "Hoefsmid app — agenda, dossier & klantcommunicatie.",
    subtitle:
      "Hoefsmid software met agenda, klantbeheer, voor- en na foto's, ETA notificaties en behandelhistorie. Werk professioneler, voorkom miscommunicatie en bouw een sterk dossier.",
    primaryCTA: { label: "Start als hoefsmid", href: "/#waitlist" },
    secondaryCTA: { label: "Voor hoefsmeden →", href: "/doelgroepen/hoefsmeden" },
    audience: "Voor hoefsmeden, hoefspecialisten en barhoof-praktijken.",
    features: [
      "Eigen agenda en planning",
      "Klantbeheer per paard en eigenaar",
      "Voor- en na foto's per behandeling",
      "Behandeling en advies vastleggen",
      "ETA melding: 'De hoefsmid is onderweg'",
      "Behandelhistorie per paard",
      "Facturering en exports",
      "Werkt offline op stal",
    ],
    faq: [
      {
        q: "Kan ik facturen versturen?",
        a: "Ja, vanaf de Professional tier (€24,99/maand) kun je facturen genereren en versturen.",
      },
      {
        q: "Werkt het als ik geen bereik heb op stal?",
        a: "Ja. Je kunt offline behandelingen invoeren; data synct zodra je weer verbinding hebt.",
      },
    ],
  },

  dierenarts: {
    slug: "dierenarts",
    eyebrow: "Functie · Dierenarts module",
    title: "Dierenarts module — compleet paardendossier.",
    subtitle:
      "Bouw een medisch dossier per paard: vaccinaties, medicatie, bevindingen, foto's en historie. Werk samen met de eigenaar en andere professionals.",
    primaryCTA: { label: "Start als dierenarts", href: "/#waitlist" },
    secondaryCTA: { label: "Voor dierenartsen →", href: "/doelgroepen/dierenartsen" },
    audience: "Voor paarden dierenartsen en mobiele klinieken.",
    features: [
      "Medisch dossier per paard",
      "Vaccinaties en herhalingen plannen",
      "Medicatie en doseringen registreren",
      "Bevindingen met foto's en video's",
      "Behandelhistorie altijd inzichtelijk",
      "Communiceer direct met eigenaar",
      "Koppelen met andere professionals",
    ],
    faq: [
      {
        q: "Voldoet EquiSight aan AVG voor medische data?",
        a: "Ja. Data wordt versleuteld opgeslagen binnen de EU. Eigenaren geven expliciet toestemming voor delen.",
      },
    ],
  },

  trainer: {
    slug: "trainer",
    eyebrow: "Functie · Trainer module",
    title: "Trainer app — coaching met data, doelen en voortgang.",
    subtitle:
      "Voor instructeurs en trainers met meerdere ruiters: zet doelen, geef feedback, volg progressie en analyseer protocollen. Maak training meetbaar en begeleiding professioneel.",
    primaryCTA: { label: "Start als trainer", href: "/#waitlist" },
    secondaryCTA: { label: "Voor trainers →", href: "/doelgroepen/trainers" },
    audience: "Voor instructeurs, trainers en coaches met meerdere ruiters.",
    features: [
      "Ruiters en paarden koppelen",
      "Trainingsdoelen instellen",
      "Feedback geven per training",
      "Wedstrijdresultaten analyseren",
      "Progressie per combinatie volgen",
      "Protocolanalyses gebruiken in trainingsfocus",
      "Gedeelde agenda met ruiters",
    ],
    faq: [
      {
        q: "Zit de Trainer module in mijn abonnement?",
        a: "Ja, de Trainer module is inbegrepen in Pro (€14,99/maand) en Professional (€24,99/maand).",
      },
    ],
  },

  fokkerij: {
    slug: "fokkerij",
    eyebrow: "Functie · Fokkerij module",
    title: "Fokkerij software — cyclus, dracht & veulens.",
    subtitle:
      "Beheer alles rond merries en fokkerij: hengstigheid tracker, inseminatiedata, drachtcontroles, echo's, stamboom en veulenontwikkeling — in één tijdlijn.",
    primaryCTA: { label: "Start met fokkerijbeheer", href: "/#waitlist" },
    secondaryCTA: { label: "Voor fokkers →", href: "/doelgroepen/fokkers" },
    audience: "Voor fokkers, merriehouders en stallen met meerdere merries.",
    features: [
      "Cyclus tracking per merrie",
      "Hengstigheid registreren",
      "Inseminatiedata vastleggen",
      "Countdown naar echo's",
      "Drachtcontroles plannen",
      "Stamboom en afstamming",
      "Veulenontwikkeling volgen",
      "Overzicht alle drachtige merries",
    ],
    faq: [
      {
        q: "Kan ik meerdere merries beheren?",
        a: "Ja, in Pro (€14,99) en hoger heb je geen limiet op het aantal merries en veulens.",
      },
      {
        q: "Werkt het ook na de geboorte?",
        a: "Zeker. Veulens krijgen automatisch een eigen paardprofiel met groeicurves en mijlpalen.",
      },
    ],
  },

  tandarts: {
    slug: "tandarts",
    eyebrow: "Functie · Tandarts module",
    title: "Paardentandarts module — gebitscontrole & dossier.",
    subtitle:
      "Registreer gebitscontroles, bevindingen, foto's en opvolgadvies. Stuur direct een rapport naar de eigenaar en bouw een sterk dossier per paard.",
    primaryCTA: { label: "Start als paardentandarts", href: "/#waitlist" },
    secondaryCTA: { label: "Bekijk Professional →", href: "/functies/professional" },
    audience: "Voor paardentandartsen en dierenartsen met gebitswerk.",
    features: [
      "Gebitscontrole registreren",
      "Bevindingen per behandeling",
      "Foto's toevoegen",
      "Rapportage aan eigenaar",
      "Opvolgadvies vastleggen",
      "Historie per paard",
      "Nieuwe afspraak direct plannen",
    ],
    faq: [
      {
        q: "Hoe vaak moet een paard naar de tandarts?",
        a: "Meestal één keer per jaar bij volwassen paarden. Jonge paarden (3–5 jaar) en senioren vaker. EquiSight stuurt automatisch herinneringen.",
      },
    ],
  },

  manege: {
    slug: "manege",
    eyebrow: "Functie · Manege module",
    title: "Manege software — lesplanning & ruiter administratie.",
    subtitle:
      "Maak je manege digitaal: lesplanning, ruiter administratie, paardenbeheer en communicatie. Meer binding met ruiters, professioneler werken.",
    primaryCTA: { label: "Vraag toegang aan", href: "/#waitlist" },
    secondaryCTA: { label: "Voor manegehouders →", href: "/doelgroepen/manegehouders" },
    audience: "Voor maneges, pensionstallen en rij(les)scholen.",
    features: [
      "Manegepaarden zichtbaar voor ruiters",
      "Naam, foto en korte info per paard",
      "Ruiters koppelen aan paarden",
      "Alleen-lezen voor privacygevoelige data",
      "Les- en trainingshistorie centraal",
      "Gebruikersbeheer met rollen",
      "Communicatie met ruiters",
    ],
    faq: [
      {
        q: "Krijgen mijn ruiters toegang tot medische data?",
        a: "Nee. Privacygevoelige gezondheidsdata is alleen voor eigenaar en stalbeheer. Ruiters zien alleen wat jij vrijgeeft.",
      },
    ],
  },

  voeding: {
    slug: "voeding",
    eyebrow: "Functie · Voeding",
    title: "Voeding paard — voederplan, advies & overzicht.",
    subtitle:
      "Maak een persoonlijk voederplan per paard. EquiCoach geeft voederadvies op basis van gewicht, werk, leeftijd en de fructaan-index.",
    primaryCTA: { label: "Start gratis", href: "/#waitlist" },
    secondaryCTA: { label: "Lees voeradvies →", href: "/kennisbank/voeradvies" },
    features: [
      "Voederplan per paard",
      "Hooi, krachtvoer en supplementen registreren",
      "Voederadvies op basis van werk & gewicht",
      "Fructaan-index waarschuwingen",
      "Wekelijkse herziening",
      "Voederplan delen met verzorger",
    ],
    faq: [
      {
        q: "Geeft EquiSight veterinair voedingsadvies?",
        a: "Nee. EquiSight is een ondersteunend hulpmiddel. Bij medische of complexe voedingsvragen raadpleeg je je dierenarts of voedingsdeskundige.",
      },
    ],
  },

  medicatie: {
    slug: "medicatie",
    eyebrow: "Functie · Medicatie",
    title: "Medicatie paard — registreren & herinneringen.",
    subtitle:
      "Houd alle medicatie per paard bij: doseringen, frequentie, einddatum en paspoortvermelding. Krijg automatisch herinneringen.",
    primaryCTA: { label: "Begin met je paard", href: "/#waitlist" },
    secondaryCTA: { label: "Bekijk gezondheid →", href: "/kennisbank/paarden-gezondheid" },
    features: [
      "Medicatie registreren per paard",
      "Dosering en frequentie",
      "Wachttermijn KNHS / FEI",
      "Einddatum en herinneringen",
      "Paspoort-relevante info",
      "Historie inzichtelijk",
    ],
    faq: [
      {
        q: "Werkt dit voor KNHS wachttermijn?",
        a: "Ja. EquiSight toont KNHS wachttermijnen en waarschuwt voor wedstrijddata.",
      },
    ],
  },

  agenda: {
    slug: "agenda",
    eyebrow: "Functie · Agenda",
    title: "Paarden agenda — afspraken, herinneringen & planning.",
    subtitle:
      "Een centrale paarden agenda met afspraken, herinneringen voor ontworming, entingen, hoefsmid en wedstrijden. Push-meldingen op je telefoon.",
    primaryCTA: { label: "Probeer EquiSight gratis", href: "/#waitlist" },
    secondaryCTA: { label: "Bekijk planning →", href: "/functies/protocol-analyse" },
    features: [
      "Eén agenda voor al je paarden",
      "Slimme herinneringen",
      "Hoefsmid, dierenarts, tandarts, fysio",
      "Ontworming en entingen",
      "Wedstrijden en startlijst meldingen",
      "Synchroniseer met Google Calendar",
    ],
    faq: [
      {
        q: "Krijg ik push-meldingen?",
        a: "Ja, push-meldingen op iOS en Android. Je bepaalt zelf wanneer en hoe vaak.",
      },
    ],
  },

  "protocol-analyse": {
    slug: "protocol-analyse",
    eyebrow: "Functie · Protocol analyse",
    title: "Protocol analyse dressuur — voor- en achterkant scannen.",
    subtitle:
      "Scan je dressuurprotocol (KNHS, FEI) en krijg direct inzicht in scores, jurycommentaar en trends. Vergelijk meerdere protocollen per combinatie.",
    primaryCTA: { label: "Probeer protocol analyse", href: "/#waitlist" },
    secondaryCTA: { label: "Voor dressuurruiters →", href: "/doelgroepen/dressuurruiters" },
    features: [
      "Voor- en achterkant scannen",
      "Klasse en proefnummer herkennen",
      "Jurylid en plek herkennen",
      "Scores per onderdeel",
      "Commentaar groeperen",
      "Trends per combinatie",
      "Vergelijken meerdere protocollen",
    ],
    faq: [
      {
        q: "Welke proeven worden ondersteund?",
        a: "Alle KNHS dressuurproeven en FEI proeven. Springprotocollen zijn in ontwikkeling.",
      },
    ],
  },

  noodnummers: {
    slug: "noodnummers",
    eyebrow: "Functie · Noodnummers paard",
    title: "Noodnummers paard — direct bellen, appen, navigeren.",
    subtitle:
      "Altijd alle noodcontacten van je paard bij de hand: dierenarts, kliniek, hoefsmid, fysio. Eén tik en je belt, appt of navigeert. Altijd gratis in EquiSight.",
    primaryCTA: { label: "Zet jouw noodcontacten klaar", href: "/#waitlist" },
    secondaryCTA: { label: "Lees over koliek →", href: "/aandoeningen/koliek" },
    accent: "danger",
    heroScreenshot: {
      url: "/assets/emergency.png",
      alt: "Noodcontacten — direct bellen, WhatsAppen of navigeren naar dierenarts, kliniek en hoefsmid",
      caption: "Eén tik. Geen paniek zoeken.",
      embeddedFrame: true,
    },
    problem:
      "Je paard heeft iets — koliek, blessure, paniek. En dan begint het zoeken. Wie bel je? Heb je het juiste nummer? Kostbare tijd gaat verloren.",
    solution:
      "Met EquiSight heb je alles direct bij de hand. Geen zoeken. Geen twijfel. Eén tik en je hebt contact.",
    features: [
      "Alle noodnummers op één plek",
      "Eén-tik bellen vanuit de app",
      "WhatsAppen met één tik",
      "Direct navigeren naar het adres",
      "Per paard eigen contactlijst",
      "Dierenarts, kliniek, hoefsmid, tandarts, fysio",
      "Adres + routebeschrijving",
      "Markeer favorieten met een ster",
      "Spoednummers (112, 144) altijd bovenaan",
    ],
    faq: [
      {
        q: "Kost de noodnummers module wat?",
        a: "Nee. Noodnummers zijn altijd gratis voor iedereen, ook in het Basic abonnement (€0).",
      },
      {
        q: "Werkt het zonder internet?",
        a: "Ja. De noodnummerlijst is offline beschikbaar — als je telefoon werkt kun je bellen.",
      },
    ],
  },

  weidegang: {
    slug: "weidegang",
    eyebrow: "Functie · Weidegang",
    title: "Weidegang paard — bijhouden, tijden & fructaan-index.",
    subtitle:
      "Volg de weidegang van je paard: tijden, weide-kwaliteit, fructaan-index waarschuwingen en wisselende rotaties. Voorkom hoefbevangenheid.",
    primaryCTA: { label: "Begin met je paard", href: "/#waitlist" },
    secondaryCTA: { label: "Wat is fructaan? →", href: "/kennisbank/fructaan-index" },
    features: [
      "Weidegang per paard registreren",
      "Tijden en duur per weide",
      "Fructaan-index per locatie",
      "Waarschuwingen bij hoog risico",
      "Wisselrotaties plannen",
      "Voorkom hoefbevangenheid",
    ],
    faq: [
      {
        q: "Hoe werkt de fructaan-index?",
        a: "Op basis van weer, seizoen en weide-type berekent EquiSight de risicofactor voor fructaan. Bij hoog risico krijg je een waarschuwing.",
      },
    ],
  },

  entingen: {
    slug: "entingen",
    eyebrow: "Functie · Entingen",
    title: "Entingen paard bijhouden — vaccinatiekalender.",
    subtitle:
      "Houd alle entingen per paard bij met automatische herinneringen voor influenza, tetanus, west-nijl en rhinopneumonie. Nooit meer een vaccinatie missen.",
    primaryCTA: { label: "Maak vaccinatiekalender", href: "/#waitlist" },
    secondaryCTA: { label: "Lees over entingen →", href: "/kennisbank/entingen" },
    features: [
      "Alle entingen registreren per paard",
      "Automatische herinneringen",
      "Influenza · tetanus · west-nijl · rhino",
      "KNHS regels ingebouwd",
      "Paspoortvermelding",
      "Geschiedenis altijd inzichtelijk",
      "Deel met dierenarts",
    ],
    faq: [
      {
        q: "Welke entingen zijn verplicht bij KNHS wedstrijden?",
        a: "Influenza-vaccinatie volgens KNHS schema is verplicht. EquiSight waarschuwt automatisch als je niet meer geldig bent voor wedstrijden.",
      },
    ],
  },

  ontwormen: {
    slug: "ontwormen",
    eyebrow: "Functie · Ontwormen",
    title: "Ontwormen paard — schema, EPG & herinneringen.",
    subtitle:
      "Persoonlijk ontwormingsschema per paard, gebaseerd op EPG-tests en seizoen. Krijg op tijd herinnering en houd de historie bij.",
    primaryCTA: { label: "Maak ontwormingsschema", href: "/#waitlist" },
    secondaryCTA: { label: "Lees: schema →", href: "/ontworming/schema-paard" },
    features: [
      "Persoonlijk schema per paard",
      "Gebaseerd op EPG-tests",
      "Seizoensgebonden ontworming",
      "Resistentie-bewust",
      "Automatische herinneringen",
      "Historie en kostenoverzicht",
    ],
    faq: [
      {
        q: "Wat is selectief ontwormen?",
        a: "Op basis van EPG-tests (eitjes per gram) ontwerm je alleen paarden die het echt nodig hebben. Zo voorkom je resistentie. Lees meer in onze kennisbank.",
      },
    ],
  },

  "gewicht-monitoring": {
    slug: "gewicht-monitoring",
    eyebrow: "Functie · Gewicht monitoring",
    title: "Gewicht paard monitoren — meten, trend & advies.",
    subtitle:
      "Houd het gewicht en de conditie van je paard bij in een trendgrafiek. Krijg waarschuwingen bij afwijkingen en koppel direct aan voederplan.",
    primaryCTA: { label: "Start met meten", href: "/#waitlist" },
    secondaryCTA: { label: "Voeding →", href: "/functies/voeding" },
    features: [
      "Gewicht registreren",
      "Conditiescore (BCS)",
      "Trendgrafiek per paard",
      "Waarschuwingen bij afwijking",
      "Koppeling met voederplan",
      "Foto-progressie",
    ],
    faq: [
      {
        q: "Heb ik een paardenweegschaal nodig?",
        a: "Niet per se. EquiSight rekent met meetband en conditiescore. Een weegschaal is precies, maar trend is belangrijker dan exacte kilo's.",
      },
    ],
  },
};

export default FUNCTIES;
